import setPieveSessionCompanyId from '@/lib/auth/setPieveSessionCompanyId.js';
import { signOut } from '@/redux/requests/sessionRequests.js';

/** Ends the session on the server and drops this tab's account data, so the next person starts clean. */
const signOutAndClear = () => {
  return async (dispatch) => {
    const res = await signOut();

    setPieveSessionCompanyId(null);
    dispatch({ type: 'RESET_PIEVE_USER_STATE' });
    dispatch({ type: 'SESSION_CONTEXT_STATUS', payload: { status: 'idle', message: null } });

    return res;
  };
};

export default signOutAndClear;
